import { render } from "./EventTicks.vue?vue&type=template&id=725705fd&scoped=true"
import script from "./EventTicks.vue?vue&type=script&lang=js"
export * from "./EventTicks.vue?vue&type=script&lang=js"

import "./EventTicks.vue?vue&type=style&index=0&id=725705fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725705fd"]])

export default __exports__